import { render, staticRenderFns } from "./JobSearchAssistanceEdit.vue?vue&type=template&id=b0517f32&"
import script from "./JobSearchAssistanceEdit.vue?vue&type=script&lang=js&"
export * from "./JobSearchAssistanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports